import '@shoelace-style/shoelace/dist/themes/light.css';
import '@shoelace-style/shoelace/dist/components/dialog/dialog';

class Video {
  constructor() {
    document.querySelectorAll('.js-video-button').forEach((button) => {
      button.addEventListener('click', () => {
        const video = document.getElementById(button.getAttribute('aria-controls'));
        const videoType = button.getAttribute('data-video-type');
        const videoParent = button.closest('.js-video');

        if (videoType === 'youtube') {
          if (this.getCookie('youtube-consent')) {
            button.toggleAttribute('inert', true);
            video.removeAttribute('inert');
            video.setAttribute('src', video.getAttribute('data-video-url'));
          } else {
            const dialog = videoParent.querySelector('.js-video-consent');
            const allowButton = dialog.querySelector('.js-video-consent-allow');
            const denyButton = dialog.querySelector('.js-video-consent-deny');

            dialog.addEventListener('sl-after-hide', () => {
              video.focus({ preventScroll: true });
            });

            dialog.show();

            denyButton.addEventListener('click', () => {
              dialog.hide();
            });

            allowButton.addEventListener('click', () => {
              button.toggleAttribute('inert', true);
              video.setAttribute('src', video.getAttribute('data-video-url'));
              video.removeAttribute('inert');

              dialog.hide();

              const allVideos = dialog.querySelector('.js-video-consent-all-videos');

              if (typeof allVideos !== 'undefined' && allVideos.checked) {
                const date = new Date();
                date.setTime(+ date + (365 * (24 * 60 * 60 * 1000)));
                const expirationDate = '; expires=' + date.toUTCString();
                document.cookie = 'youtube-consent=1' + expirationDate + '; path=/';
              }
            });
          }
        } else {
          button.toggleAttribute('inert', true);
          this.removeAttribute('inert');
          this.play();
        }
      });
    });
  }

  getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }
}

export default new Video();



